export default "/images/hoorn-animation-202-cutoff.webp?397b5baf2823085dedf6157c6409fd10";